import React from "react";
import * as LucideIcons from "lucide-react";
import { AppWindow, LucideProps } from "lucide-react";

type LucideIconProps = Omit<LucideProps, "name"> & {
  name?: string | null;
};

const LucideIcon: React.FC<LucideIconProps> = ({ name, ...rest }) => {
  const iconName = (name || "").trim();
  const IconComponent = iconName
    ? (LucideIcons as unknown as Record<
        string,
        React.ComponentType<LucideProps> | undefined
      >)[iconName]
    : undefined;

  if (IconComponent) {
    return <IconComponent {...rest} />;
  }
  return <AppWindow {...rest} />;
};

export default LucideIcon;
